import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {WorkforceTeamMembersState} from '../../../services/payroll-workforce/workforce-team-members.state';
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-payroll-workforce-members',
  templateUrl: './payroll-workforce-members.component.html',
  styles: ['.member-row {display:flex;gap:12px;align-items:center;padding:12px 0;border-bottom:1px solid #ddd} .member-row small {display:block} nav {display:flex;gap:12px;margin-top:12px} mat-radio-group {display:flex;flex-wrap:wrap;gap:16px;margin:16px 0} section {margin-bottom:16px}'],
})
export class PayrollWorkforceMembersComponent {
  @Input() state!: WorkforceTeamMembersState;
  @Input() disabled = false;
}
